module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper dashboard-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-xl-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-pad padding-fifthin",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad padding-fifthin"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('i', {
    staticClass: "palette-Pink-500 bg ti-shopping-cart-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "palette-Pink-500 text value"
  }, [_vm._v("648")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Items Sold")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 bor-bottom"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('i', {
    staticClass: "palette-Purple-500 bg ti-link"
  }), _vm._v(" "), _c('div', {
    staticClass: "palette-Purple-500 text value"
  }, [_vm._v("47.5"), _c('strong', [_vm._v("K")])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Followers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 bor-right"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('i', {
    staticClass: "palette-Deep-Purple-500 bg ti-wallet"
  }), _vm._v(" "), _c('div', {
    staticClass: "value palette-Deep-Purple-500 text"
  }, [_c('strong', [_vm._v("$")]), _vm._v("764")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Daily Earnings")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "devin-table-dash centered pad-box"
  }, [_c('i', {
    staticClass: "ti-bag palette-Light-Blue-500 bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "value palette-Light-Blue-500 text"
  }, [_vm._v("256")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Products")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xl-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-pad padding-fifthin",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad padding-fifthin"
  }, [_c('div', {
    staticClass: "pad-box"
  }, [_c('div', {
    staticClass: "devin-table-dash bigger"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("3059")]), _vm._v(" "), _c('div', {
    staticClass: "trending trending-up palette-Amber-500 bg"
  }, [_c('span', [_vm._v("15%")])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Products Sold")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "el-chart-w"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 0],
      "gradient": ['#3bd6c6', '#3b5998']
    }
  })], 1), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xl-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body no-pad padding-fifthin",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest "
  }, [_c('div', {
    staticClass: "wrap-no-pad padding-fifthin"
  }, [_c('div', {
    staticClass: "pad-box"
  }, [_c('div', {
    staticClass: "element-info-with-icon smaller"
  }, [_c('div', {
    staticClass: "element-info-text"
  }, [_c('h5', [_vm._v("Monthly Revenue")]), _vm._v(" "), _c('div', [_vm._v("Calculated every month")])])]), _vm._v(" "), _c('div', {
    staticClass: "devin-progress-bar"
  }, [_c('el-progress', {
    staticClass: "circle-one",
    attrs: {
      "type": "circle",
      "percentage": 63,
      "width": 50,
      "stroke-width": 2,
      "status": "success"
    }
  }), _vm._v(" "), _c('el-progress', {
    staticClass: "bor-left bor-right",
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "circle",
      "percentage": 75,
      "width": 125,
      "stroke-width": 6
    }
  }), _vm._v(" "), _c('el-progress', {
    staticClass: "circle-two",
    attrs: {
      "type": "circle",
      "percentage": 89,
      "width": 50,
      "stroke-width": 2,
      "status": "exception"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "os-progress-bar primary"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xl-6"
  }, [_c('div', {
    staticClass: "food"
  }, [_c('div', {
    staticClass: "cover",
    staticStyle: {
      "background-image": "url(https://source.unsplash.com/category/food/800x600)"
    }
  }, [_c('label', [_c('i', {
    staticClass: "ti-medall-alt"
  }), _vm._v(" "), _c('font', [_vm._v("CULINARY")])], 1), _vm._v(" "), _c('a', {
    staticClass: "download",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-truck"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('a', {
    staticClass: "recipe",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-pencil-alt"
  }), _vm._v(" "), _c('font', [_c('h3', [_vm._v("76.5%")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-food"
  }, [_c('ul', [_c('li', [_c('strong', [_vm._v("Sweetness")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 15,
      "percentage": 85
    }
  })], 1), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Acidity")]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 15,
      "percentage": 60
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xl-6"
  }, [_c('div', {
    staticClass: "container-widget-two"
  }, [_c('div', {
    staticClass: "widget-two"
  }, [_c('div', {
    staticClass: "section section-graph"
  }, [_c('div', {
    staticClass: "graph-info"
  }, [_c('i', {
    staticClass: "ti-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "graph-info-big"
  }, [_vm._v("454.757")]), _vm._v(" "), _c('span', {
    staticClass: "graph-info-small"
  }, [_vm._v("+5.78 (5.71%)")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "graph"
    }
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 8, 9, 5, 9],
      "gradient": ['#ffffff', '#ffffff']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section section-info"
  }, [_c('span', {
    staticClass: "info-time"
  }, [_vm._v("Today 2:25 PM")]), _vm._v(" "), _c('h3', {
    staticClass: "info-title"
  }, [_vm._v("Salt Lake City, Utah")]), _vm._v(" "), _c('div', {
    staticClass: "info-block"
  }, [_c('dl', [_c('dt', [_c('i', {
    staticClass: "ti-stats-up"
  })]), _vm._v(" "), _c('dt', [_vm._v("13.5 M")]), _vm._v(" "), _c('dd', [_vm._v("Shares Traded")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-block last"
  }, [_c('dl', [_c('dt', [_c('i', {
    staticClass: "ti-stats-down"
  })]), _vm._v(" "), _c('dt', [_vm._v("28.44")]), _vm._v(" "), _c('dd', [_vm._v("Market Cap")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-xl-7 col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "weather"
    }
  }, [_c('div', {
    staticClass: "panelLeft"
  }, [_c('div', {
    staticClass: "top-cal-devin"
  }, [_c('p', [_vm._v("JUNY 21, 2017")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://source.unsplash.com/collection/431862/800x600",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "temp"
  }, [_c('p', [_vm._v("10°")]), _vm._v(" "), _c('p', [_vm._v("New York City")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panelRight"
  }, [_c('div', {
    staticClass: "customHeight"
  }, [_c('p', [_vm._v("Statistics")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "wi wi-thermometer"
  }), _vm._v(" "), _c('p', [_vm._v("35%")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "wi wi-day-rain-mix"
  }), _vm._v(" "), _c('p', [_vm._v("Easterly")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "wi wi-cloudy-gusts"
  }), _vm._v(" "), _c('p', [_vm._v("7 mph")])])])]), _vm._v(" "), _c('div', {
    staticClass: "remainingHeight"
  }, [_c('ul', {
    staticClass: "inline"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("Today")]), _vm._v(" "), _c('li', [_vm._v("Week")])]), _vm._v(" "), _c('ul', {
    staticClass: "forecast"
  }, [_c('li', [_c('span', {
    staticClass: "time"
  }, [_vm._v("Now")]), _vm._v(" "), _c('span', {
    staticClass: "temp"
  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
    staticClass: "conditions"
  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "time"
  }, [_vm._v("6 AM")]), _vm._v(" "), _c('span', {
    staticClass: "temp"
  }, [_vm._v("23°C")]), _vm._v(" "), _c('span', {
    staticClass: "conditions"
  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "time"
  }, [_vm._v("6:59 AM")]), _vm._v(" "), _c('span', {
    staticClass: "temp"
  }, [_vm._v("Sunrise")]), _vm._v(" "), _c('span', {
    staticClass: "conditions"
  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "time"
  }, [_vm._v("7 AM")]), _vm._v(" "), _c('span', {
    staticClass: "temp"
  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
    staticClass: "conditions"
  }, [_vm._v("Partly Cloudy")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xl-5 col-sm-12"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__header"
  }, [_c('h2', {
    staticClass: "widget__header-title"
  }, [_vm._v("\n                                  DNTM\n                                  "), _c('span', {
    staticClass: "widget__header-author"
  }, [_vm._v("\n                                    by Abine\n                                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('a', {
    staticClass: "nav__item",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('a', {
    staticClass: "nav__item",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  })]), _vm._v(" "), _c('a', {
    staticClass: "nav__item",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "widget__body"
  }, [_c('div', {
    staticClass: "flash"
  }, [_c('strong', [_vm._v("All 6")]), _vm._v(" companies blocked now ")]), _vm._v(" "), _c('div', {
    staticClass: "accordion"
  }, [_c('div', {
    staticClass: "accordion__item "
  }, [_c('div', {
    staticClass: "accordion__header"
  }, [_c('i', {
    staticClass: "fa fa-minus accordion__state-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Social Networks")])]), _vm._v(" "), _c('div', {
    staticClass: "accordion__body"
  }, [_c('div', {
    staticClass: "accordion__body-item"
  }, [_c('i', {
    staticClass: " fa ti-facebook"
  }), _vm._v(" Facebook ")]), _vm._v(" "), _c('div', {
    staticClass: "accordion__body-item"
  }, [_c('i', {
    staticClass: " fa ti-twitter"
  }), _vm._v(" Twitter ")]), _vm._v(" "), _c('div', {
    staticClass: "accordion__body-item"
  }, [_c('i', {
    staticClass: " fa ti-instagram"
  }), _vm._v(" Instagram ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f207bd3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/DashboardSecond.vue
// module id = 1146
// module chunks = 2